/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Directive } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from './value.accessor';

const TEXT_VALUE_SELECTOR_LIST = `
  dcr-text-field[formControl]:not([type="number"]):not([type="date"]),
  dcr-text-field[formControlName]:not([type="number"]):not([type="date"]),
  dcr-text-field[ngModel]:not([type="number"]):not([type="date"]),
`;

@Directive({
  selector: TEXT_VALUE_SELECTOR_LIST,
  host: {
    '(input)': 'handleChangeEvent($event.target.value)',
    '(change)': 'handleChangeEvent($event.target.value)',
    '(focusout)': 'handleBlurEvent()',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextValueAccessor,
      multi: true,
    },
  ],
})
export class TextValueAccessor extends ValueAccessor {}
